<template>
    <div>
        <el-dialog
            title="编辑楼盘信息"
            :visible.sync="showdialog"
            width="1200px"
            @close="back"
            v-dialogDrag>

            <div class="base-warp">
                <el-row>
                    <el-col class="base-col" :span="16" :offset="0">
                        <el-form class="base-form" :model="form" label-width="80px" :inline="false" size="mini">
                            <el-form-item label="相册">
                                <div class="left-row">
                                    <el-carousel :interval="4000" type="card" height="200px">
                                        <el-carousel-item v-for="(item, index) in album" :key="index">
                                            <el-image class="img" :src="item.path" fit="scale-down"></el-image>
                                            <div class="name">{{item.name}}</div>
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                                <div class="right-edit-box" v-if="form._id">
                                    <project-album2 :id="form.id"></project-album2>
                                </div>
                            </el-form-item>
                            <el-form-item label="楼盘名称">
                                <el-input v-model="form.name"></el-input>
                            </el-form-item>
                            <el-form-item label="标签">
                                <div class="tags-box">
                                    <div class="tags" v-if="form.tags">
                                        <div class="tag" v-for="(tag, index) in form.tags" :key="index">{{tag}}</div>
                                    </div>
                                    <div class="add-tag" v-if="form.tags">
                                        <project-tags @getTags="getTags" :propTags="form.tags"></project-tags>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="优惠标签">
                                <div class="flex-box">
                                    <div class="col">
                                        <el-input v-model="form.mark" placeholder="" clearable></el-input>
                                    </div>
                                    <div class="col">
                                        <div class="tags-box mark-tags">
                                            <div class="tags">
                                                <div class="tag" @click="setMark('专家陪看')">专家陪看</div>
                                                <div class="tag" @click="setMark('看房有礼')">看房有礼</div>
                                                <div class="tag" @click="setMark('专车看房')">专车看房</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="城市区域">
                                <el-cascader
                                v-model="form.region"
                                :options="regions"
                                :props="{label: 'label', value: 'label', children: 'children'}">
                                </el-cascader>
                            </el-form-item>
                            <el-form-item label="地址">
                                <div class="address-input" @click="showmap">{{form.location.address||'点击开始选择位置'}}</div>
                            </el-form-item>
                            <!-- <el-form-item label="地址">
                                <div class="left-row">
                                    <el-input v-model="form.location.address" placeholder="请输入楼盘地址" clearable></el-input>
                                    <div>经纬度：{{location.lat}},{{location.lng}}</div>
                                </div>
                                <div class="right-edit-box">
                                    <el-button type="primary" size="mini" @click="loca">
                                        <span class="el-icon-location">定位</span>
                                    </el-button>
                                </div>
                            </el-form-item> -->
                            <el-form-item label="分数">
                                <el-row>
                                    <el-col :span="12" :offset="0">
                                        <el-form class="grade-form" :model="grade" label-width="140px" :inline="false" size="mini">
                                            <el-form-item label="">
                                                <div class="grade-total">
                                                    <el-image class="img" src="https://api.hangehouse.com/static/advice.png" fit="fill" :lazy="true"></el-image>
                                                    <div class="text-box">
                                                        <div class="gra">{{grade.total}}</div>
                                                        <div class="ad">HOUSE INVEST</div>
                                                        <div class="hao">投资指数</div>
                                                    </div>
                                                </div>
                                                
                                            </el-form-item>
                                            <el-form-item label="项目地段（占60%）">
                                                <div class="slider-box flex-box">
                                                    <el-slider class="slider" v-model="grade.district" :min="0" :max="10" :step="0.1" :vertical="false" @change="sliderchange"></el-slider>
                                                    <span class="s-text">{{grade.district}}</span>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="产品力（占30%）">
                                                <div class="slider-box flex-box">
                                                    <el-slider class="slider" v-model="grade.product" :min="0" :max="10" :step="0.1" :vertical="false" @change="sliderchange"></el-slider>
                                                    <span class="s-text">{{grade.product}}</span>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="品牌价值（占10%）">
                                                <div class="slider-box flex-box">
                                                    <el-slider class="slider" v-model="grade.brand" :min="0" :max="10" :step="0.1" :vertical="false" @change="sliderchange"></el-slider>
                                                    <span class="s-text">{{grade.brand}}</span>
                                                </div>
                                            </el-form-item>
                                        </el-form>
                                    </el-col>
                                    <el-col :span="12" :offset="0">
                                        <div class="charts-box">
                                            <el-row class="charts-list" v-for="(item, index) in charts" :key="index">
                                                <el-col class="label" :span="5" :offset="0">
                                                    <el-input v-model="item.label" placeholder="" size="mini"></el-input>
                                                    </el-col>
                                                <el-col class="score" :span="15" :offset="0">
                                                    <div class="slider-box flex-box">
                                                        <el-slider class="slider" v-model="item.score" :min="0" :max="10" :step="0.1" :vertical="false"></el-slider>
                                                        <span class="s-text">{{item.score}}</span>
                                                    </div>
                                                </el-col>
                                                <el-col class="del" :span="4" :offset="0">
                                                    <el-button type="danger" size="mini" @click="delChart(index)" plain>
                                                        <span class="el-icon-delete"></span>
                                                    </el-button>
                                                </el-col>
                                            </el-row>
                                            <div class="charts-list">
                                                <el-button type="primary" size="mini" @click="addCharts">
                                                    <span class="el-icon-plus">加一个</span>
                                                </el-button>
                                            </div>
                                        </div>
                                        
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="基础信息">
                                <el-form label-width="40px" :inline="false" size="normal">
                                    <el-form-item label="项目">
                                        <span>{{form.name}}</span>
                                    </el-form-item>
                                    <el-form-item label="地址">
                                        <span>{{form.location.address}}</span>
                                    </el-form-item>
                                </el-form>
                                <div class="right-edit-box" v-if="form._id">
                                    <project-basics :id="form._id['$oid']"></project-basics>
                                </div>
                            </el-form-item>
                            <el-form-item label="项目亮点">
                                <div class="left-row" v-if="lightsopt">
                                    <p class="lightspot" v-text="lightsopt"></p>
                                </div>
                                <div class="right-edit-box"  v-if="form._id">
                                    <project-lightspot :id="form._id['$oid']"></project-lightspot>
                                </div>
                            </el-form-item>
                            <el-form-item label="购房顾问">
                                <div class="left-row">
                                    <div class="guwen-box">
                                        <div class="guwen-list" v-for="(item, index) in brokers" :key="index">
                                            <div class="guwen-warp">
                                                <div class="guwen-label">
                                                    <el-avatar class="img-box" icon="el-icon-user-solid" :size="50" shape="circle" v-if="item.ltpic" :src="item.ltpic[0]" fit="fill"></el-avatar>
                                                </div>
                                                <div class="guwen-info">
                                                    <div class="text">
                                                        <span class="name">{{item.name}}</span>
                                                        <span><span class="price">{{item.zixunlen}}人</span>咨询过</span>
                                                    </div>
                                                    <div class="tags" v-if="item.tags">
                                                        <div class="tag" v-for="(tag, index) in item.tags" :key="index">{{tag}}</div>
                                                    </div>
                                                    <div class="call">
                                                        <span>电话：{{item.telephone}}</span>
                                                    </div>
                                                </div>
                                                <div class="import" v-if="item.type=='important'">主要</div>
                                            </div>
                                            <div class="del-box">
                                                <el-button type="danger" size="mini" plain @click="delbroker(index)">
                                                    <span class="el-icon-delete"></span>
                                                </el-button>
                                                <el-button type="success" size="mini" plain @click="brokerImportant(item)">设为主要</el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="right-edit-box">
                                    <project-guwen @getBroker="getBroker"></project-guwen>
                                </div>
                            </el-form-item>
                            <el-form-item label="楼盘动态">
                                <div class="left-row">
                                    <div class="dynamic" v-if="dynamic">
                                        <div class="dy-head">
                                            <div class="flex-box">
                                                <div class="col" :class="{active: dynamic.active_step==index, disabled: dynamic.active_step<index}" v-for="(text, index) in dynamics" :key="index">
                                                    <div class="bg1" v-if="index==0"></div>
                                                    <div class="b1"></div>
                                                    <div class="b2"></div>
                                                    <span class="text">{{text}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dy-info" v-if="dynamic.active_step==0">
                                            <div class="line"></div>
                                            <div class="dot"></div>
                                            <div class="time">{{dynamic.step1.time}}</div>
                                            <div class="text">{{dynamic.step1.content}}</div>
                                        </div>
                                        <div class="dy-info" v-if="dynamic.active_step==1">
                                            <div class="line"></div>
                                            <div class="dot"></div>
                                            <div class="time">{{dynamic.step2.time}}</div>
                                            <div class="text">{{dynamic.step2.content}}</div>
                                        </div>
                                        <div class="dy-info" v-if="dynamic.active_step==2">
                                            <div class="line"></div>
                                            <div class="dot"></div>
                                            <div class="time">{{dynamic.step3.time}}</div>
                                            <div class="text">{{dynamic.step3.content}}</div>
                                        </div>
                                        <div class="dy-info" v-if="dynamic.active_step==3">
                                            <div class="line"></div>
                                            <div class="dot"></div>
                                            <div class="time">{{dynamic.step4.time}}</div>
                                            <div class="text">{{dynamic.step4.content}}</div>
                                        </div>
                                        <div class="dy-info" v-if="dynamic.active_step==4">
                                            <div class="line"></div>
                                            <div class="dot"></div>
                                            <div class="time">{{dynamic.step5.time}}</div>
                                            <div class="text">{{dynamic.step5.content}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="right-edit-box" v-if="form._id">
                                    <project-dynamic :id="form._id['$oid']"></project-dynamic>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <div class="btn-box">
                                    <el-button type="primary" size="default" @click="confirm">保存</el-button>
                                    <el-button type="default" size="default" @click="showdialog = false">取消</el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="8" :offset="0"></el-col>
                </el-row>
            </div>
            <tencent-map @getlocation="getlocation" :lat="form.location.lat" :lng="form.location.lng"></tencent-map>
        </el-dialog>
    </div>
</template>

<script>
import ProjectAlbum2 from '../../../components/project-album';
import ProjectTags from '../../../components/project-tags.vue';
import ProjectBasics from '../../../components/project-basics.vue';
import ProjectLightspot from '../../../components/project-lightspot.vue';
import ProjectGuwen from '../../../components/project-guwen.vue';
import ProjectDynamic from '../../../components/project-dynamic.vue';
import ProjectEvaluate from '../../../components/project-evaluate.vue';
import ProjectExpert from '../../../components/project-expert.vue';
import TencentMap from '../../../components/invest/tencent-map.vue';
export default {
    components: {
        ProjectAlbum2, ProjectTags, ProjectBasics, ProjectLightspot, ProjectGuwen, ProjectDynamic, ProjectEvaluate, ProjectExpert,
        TencentMap, 
    },
    data() {
        return {
            id: '',
            showdialog: true,
            regions: [],
            form: {
                name: '',
                lightspot: '',
                location: {},
                address: '',
                mark: '',
                city: '',
            },
            grade: {
                total: 6,
                district: 6,
                product: 6,
                brand: 6,
            },
            charts: [
                {
                    label: '户型',
                    score: 6,
                },
                {
                    label: '景观',
                    score: 6,
                },
                {
                    label: '装修',
                    score: 6,
                },
                {
                    label: '配套',
                    score: 6,
                },
                {
                    label: '物业',
                    score: 6,
                },
            ],
            dynamics: ['待入市', '即将取证', '正在认筹', '摇号开盘', '持续销售'],
            active_step: 2,
            brokers: [],
            dynamic: '',
            lightsopt: '',
            expertRemark: '',
            album: [],
            managedCity:"",
        }
    },
    mounted () {
        var id = this.$route.query.id;
        if (!id) {
            this.$message.error('缺少id,不能继续操作');
            this.$router.go(-1);
            return;
        }
        this.id = id;
        this.getData();
        this.getCityList();
        let managedCity = this.$store.getters.getuser.city;
        this.managedCity = managedCity;
    },
    methods: {
        getlocation(item) {
            if (item.address) {
                this.form.location = item;
                this.form.city = item.city;
            }
        },
        showmap() {
            this.$store.commit('setshowtmap', true)
        },
        setMark(mark) {
            this.form.mark = mark;
        },
        getCityList() {
            this.$api.getCityList('').then(
                data=>{
                    if(this.managedCity !== '全部'){
                        data = data.filter(item=>{
                            return item.label === this.managedCity;
                        })
                    }
                    this.regions = data;
                }
            )
        },
        getData() {
            var params = {
                id: this.id,
            }
            this.$api.getProjectById(params).then(
                data=>{
                    if (data.region) {
                        data.region = data.region.split('-');
                        data.region.unshift(data.city);
                    }
                    if (data.location){
                        if (typeof data.location == 'string'){
                            data.location = JSON.parse(data.location);
                        }
                    }
                    if (data.brokers){
                        var brokers = JSON.parse(data.brokers);
                        for (var broker of brokers){
                            if (typeof broker.ltpic == 'string') broker.ltpic = JSON.parse(broker.ltpic);
                            if (typeof broker.tags == 'string') broker.tags = JSON.parse(broker.tags);
                        }
                        this.brokers = brokers;
                    } 

                    if (data.album) this.album = JSON.parse(data.album);
                    if (data.tags) {
                        data.tags = JSON.parse(data.tags)
                    } else {
                        data.tags = [];
                    }
                    if (!data.mark) data.mark = '';
                    if (data.grade) this.grade = JSON.parse(data.grade);
                    if (data.charts) this.charts = JSON.parse(data.charts);
                    if (data.dynamic) this.dynamic = data.dynamic;
                    if (data.lightsopt) this.lightsopt = data.lightsopt;
                    if (data.expertRemark) this.expertRemark = data.expertRemark;
                    this.form = data;
                }
            )
        },
        confirm() {
            var params = {
                id: this.id,
                name: this.form.name,
                tags: JSON.stringify(this.form.tags),
                region: JSON.stringify(this.form.region),
                location: JSON.stringify(this.form.location),
                brokers: JSON.stringify(this.brokers),
                grade: JSON.stringify(this.grade),
                charts: JSON.stringify(this.charts),
                mark: this.form.mark,
            }
            this.$api.editProjectInfo(params).then(
                data=>{
                    this.$message.success(data);
                }
            )
        },
        delChart(index) {
            this.charts.splice(index, 1);
        },
        addCharts() {
            var obj = {
                label: '',
                score: 6,
            }
            this.charts.push(obj);
        },
        back() {
            this.$router.go(-1)
        },
        getTags(e) {
            this.form.tags = e;
        },
        getBroker(e) {
            this.brokers = this.brokers.concat(e);
        },
        delbroker(index) {
            this.brokers.splice(index, 1);
        },
        brokerImportant(row, index) {
            var name = row.name;
            this.$confirm('确定将'+name+'设为主要购房顾问？').then(
                confirm=>{
                    var brokers = this.brokers;
                    for(var broker of brokers){
                        if (broker.name == name){
                            broker.type = 'important';
                        } else {
                            broker.type = 'normol';
                        }
                    }
                    this.brokers = brokers;
                },
                cancel=>{}
            )
        },
        sliderchange(e) {
            var district = this.grade.district;
            var product = this.grade.product;
            var brand = this.grade.brand;

            var total = (district*6+product*3+brand*1)/10;
            this.grade.total = total.toFixed(1);
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.el-carousel__item {
    background: #fff;
    border: 1px dashed #999;
    .img{
        width: 270px;
        height: 202px;
        vertical-align: middle;
        position: relative;
    }
    .name{
        position: absolute;
        color: #fff;
        padding: 0 6px;
        background: rgba(0, 0, 0, 0.4);
        bottom: 4px;
        left: 4px;
    }
}

.el-carousel__item:nth-child(2n) {
    background-color: #fff;
    border: 1px dashed #eee;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #fff;
    border: 1px dashed #eee;
}
.base-warp{
    .base-col{
        border-right: 1px solid #eee;
        padding: 10px;
        .btn-box{
            text-align: right;
        }
        &:last-child{
            border-right: none;
        }
        .mark-tags{
            margin-left: 20px;
            margin-top: 2px;
        }
        .tags-box{
            position: relative;
            .tags{
                .tag{
                    background: #efefef;
                    color: #848285;
                    line-height: 20px;
                    cursor: pointer;
                }
            }
            .add-tag{
                position: absolute;
                right: 0;
                top: 0;
                color:#3a8ee6;
            }
        }
        .slider-box{
            .slider{
                flex: 1;
            }
            .s-text{
                width: 20px;
                text-align: center;
            }
        }
        .right-edit-box{
            position: absolute;
            right: 0;
            top: 0;
        }
        .left-row{
            width: 80%;
            .evaluate{
                span{
                    margin-right: 10px;
                }
            }
            .evaluating{
                position: relative;
                overflow: hidden;
                margin-right: 120px;
                height: 63px;
                .label{
					width: 82px;
					height: 63px;
					overflow: hidden;
					position: absolute;
					top: 0;
					left: 0;
					.img-box{
						width: 82px;
						.img{
							max-width: 82px;
							max-height: 63px;
							vertical-align: middle;
						}
					}
				}
				.content{
					padding-left: 96px;
					box-sizing: border-box;
					width: 100%;
					overflow: hidden;
					line-height: 21px;
					.title{
						color: #333;
						white-space: nowrap;
						width: 100%;
						overflow: hidden;
						text-overflow: ellipsis;
						margin-top: -4px;
					}
					.text{
						color: #95989d;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}
				}
            }
            .dynamic{
                position: relative;
                margin-right: 140px;
                .dy-head{
					padding-bottom: 20px;
					.col.active{
						.bg1,.b1,.b2{
							background-color: #feb238;
						}
						.text{
							color: #fff;
						}
					}
					.col.disabled{
						.bg1,.b1,.b2{
							background-color: #f7f7f7;
						}
						.text{
							color: #848285;
						}
					}
					.col{
						width: 100%;
						margin-left: 5px;
						position: relative;
						&:last-child{
							margin-right: 5px;
						}
						.bg1{
							position: absolute;
							left: -5px;
							top: 0;
							height: 50px;
							width: 15px;
							background-color: #fef7e5;
						}
						.b1{
							background-color: #fef7e5;
							width: 100%;
							height: 25px;
							transform: skewX(25deg);
						}
						.b2{
							background-color: #fef7e5;
							width: 100%;
							height: 25px;
							transform: skewX(-25deg);
						}
						.text{
							position: absolute;
							width: 100%;
							height: 20px;
							line-height: 20px;
							text-align: center;
							top: 15px;
							left: 5px;
							color: #020100;
							font-size: 14px;
						}
					}
				}
				.dy-info{
					padding-left: 40px;
					box-sizing: border-box;
                    position: relative;
                    width: 100%;
					overflow: hidden;
					.line{
						width: 2px;
						height: 80px;
						background-color: #c5cac4;
						position: absolute;
						left: 19px;
						top: 10px;
						z-index: 1;
					}
					.dot{
						width: 15px;
						height: 15px;
						border-radius: 10px;
						background-image: linear-gradient(to right bottom, #ffe40c, #ffae00);
						position: absolute;
						top: 7px;
						left: 12px;
						z-index: 2;
					}
					.time{
						margin-bottom: 0px;
						margin-top: 5px;
					}
					.text{
						color: #848283;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        line-height: 20px;
					}
				}
            }
            .lightspot{
                -webkit-line-clamp: 2;
                overflow: hidden;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                text-overflow: ellipsis;
                white-space: pre-wrap;
            }
            .guwen-box{
                position: relative;
                overflow: hidden;
                margin-right: 10px;
                .guwen-list{
                    position: relative;
                    .guwen-warp{
                        position: relative;
                        margin-bottom: 10px;
                        padding: 10px 0;
                        background-image: linear-gradient(to right, #fffefd, #fff6ef);
                        margin-right: 140px;
                    }
                    .del-box{
                        position: absolute;
                        right: 0;
                        top: 24px;
                    }
                    .guwen-label{
                        position: absolute;
                        width: 50px;
                        height: 50px;
                        overflow: hidden;
                        .img-box{
                            width: 50px;
                            height: 50px;
                            border-radius: 50px;
                            overflow: hidden;
                            .img{
                                max-width: 50px;
                                max-height: 50px;
                                vertical-align: middle;
                            }
                        }
                    }
                    .guwen-info{
                        padding-left: 60px;
                        box-sizing: border-box;
                        width: 100%;
                        position: relative;
                        .guwen-warp{
                            position: relative;
                        }
                        .text{
                            color: #4b5053;
                            font-size: 14px;
                            .name{
                                font-size: 14px;
                                // font-weight: bold;
                                color: #071110;
                                margin-right: 15px;
                            }
                            .price{
                                color: #ff7551;
                            }
                        }
                        .tags{
                            margin-bottom: 5px;
                            width: 100%;
                            min-height: 21px;
                            .tag{
                                background-color: #fff;
                                border: 1px solid #d7d8dc;
                                color: #4b5053;
                                line-height: 16px;
                            }
                        }
                        .call{
                            position: absolute;
                            right: 20px;
                            top: 0;
                        }
                    }
                    .import{
                        position: absolute;
                        right: 20px;
                        bottom: 10px;
                    }
                }
            }
        }
    }
}
.base-form{
    ::v-deep .el-form-item.el-form-item--mini{
        border-bottom: 4px solid #f7f7f7;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }
}
.grade-form{
    padding-right: 10px;
    border-right: 1px solid #f7f7f7;
    ::v-deep .el-form-item.el-form-item--mini{
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
    }
    .grade-total{
        position: relative;
        height: 100px;
        .img{
            position: absolute;
            width: 100%;
        }
        .text-box{
            width: 100%;
            text-align: center;
            overflow: hidden;
            .gra{
                font-size: 36px;
                font-weight: bold;
                margin-top: 14px;
                margin-bottom: 4px;
            }
            .ad{
                font-size: 12px;
                color: #edd36e;
                line-height: 12px;
            }
            .hao{
                font-weight: bold;
                line-height: 14px;
                margin-top: 10px;
            }
        }
    }
}
.charts-box{
    padding-left: 10px;
    .charts-list{
        .label{
            padding-right: 4px;
        }
        .score{
            padding-right: 4px;
        }
        .del{

        }
    }
}
.address-input{
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
    font-size: 12px;
}
</style>